import { render, staticRenderFns } from "./adminEdit.vue?vue&type=template&id=716a8800&"
import script from "./adminEdit.vue?vue&type=script&lang=ts&"
export * from "./adminEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports